import ThreeDotsMenu from "../../../reusable-components/three-dots-menu/ThreeDotsMenu";
import { PanelOption } from "../../../reusable-components/three-dots-panel/ThreeDotsPanel";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";

interface IProps {
  onEditClick: () => void;
}

const UsersTableRowThreeDotsMenu =
  ({
    onEditClick,

  }: IProps) => {
    const { t: tCommon } = useTranslation("common");

    const editOption: PanelOption = {
      text: tCommon("edit"),
      onClick: () => onEditClick(),
      Icon: <FontAwesomeIcon icon={faPen} />,
    };

    const panelOptions = [editOption];

    return (
      <ThreeDotsMenu panelOptions={panelOptions}
                     direction={"bottom_left"} />
    );
  };

export default UsersTableRowThreeDotsMenu;
